import { Col, Form, Input, Modal, Row, Segmented } from 'ui';

export type EventInviteesFiltersFormValues = {
  search?: string;
  type: EventInviteesFiltersType;
};

export type EventInviteesFiltersType = 'community' | 'individual';

type P = {
  hasDistributionList: boolean;
  type: EventInviteesFiltersType;
};

const EventInviteesFilters = ({ hasDistributionList, type }: P) => (
  <Modal.ScrollableContent.Header>
    <Row gutter="ms">
      {hasDistributionList ? (
        <Col span={8}>
          <Form.Item<EventInviteesFiltersFormValues> label="People" name="type" noOptional>
            <Segmented<EventInviteesFiltersType>
              options={[
                { label: 'Individual', value: 'individual' },
                { label: 'Community', value: 'community' },
              ]}
              size="large"
            />
          </Form.Item>
        </Col>
      ) : null}
      {type === 'community' ? null : (
        <Col span={hasDistributionList ? 16 : 24}>
          <Form.Item<EventInviteesFiltersFormValues> label="Search" name="search" noOptional>
            <Input hasSearch />
          </Form.Item>
        </Col>
      )}
    </Row>
  </Modal.ScrollableContent.Header>
);

export default EventInviteesFilters;
